<template>
    <section class="delivery-section">
        <div class="navbar-block">
            <NavBar/>
        </div>
        <Description />
        <FooterBar />
    </section>
</template>

<script>
    import NavBar from "../layout/NavBar";
    import FooterBar from "../layout/FooterBar";
    import Description from "./layout/description";
    export default {
        name: "Delivery",
        components: {Description, FooterBar, NavBar}
    }
</script>

<style  lang="scss" scoped>
    .delivery-section {
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .navbar-block {
            width: 100%;
            border-bottom: 0.5px solid #a2a2a2;
            background: #ffffff;
        }
    }
</style>